import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "flex flex-col my-component-y-spacing-lg lg:my-component-y-spacing-3xl [--keen-slider-spacing:8px] [--keen-slider-per-view:1.25] md:[--keen-slider-per-view:2] lg:[--keen-slider-per-view:4]",
    contentSection: "flex justify-between items-center",
    heading: "text-heading-sm lg:text-heading-lg col-start-1 col-end-1 row-span-1",
    navigationButtonsWrapper: "w-auto pointer-events-none",
    link: "text-label-md lg:text-heading-2xs",
    navigationButton: "pointer-events-auto w-10 h-10 flex justify-center items-center bg-black rounded-full group hover:scale-105 active:scale-95 transition-transform fill-white",
    innerNavigationButton: "pointer-events-auto w-4 h-4 group-hover:fill-white",
    itemsWrapper: "flex items-center relative overflow-hidden",
    item: "w-[calc((100%-((var(--keen-slider-per-view)-1)*var(--keen-slider-spacing)))/var(--keen-slider-per-view))] shrink-0"
  },
  variants: {
    backgroundColor: {
      white: {
        base: "bg-background-page"
      },
      gray: {
        base: "bg-background-surface-1 py-8 rounded-lg"
      }
    },
    hasUnderlineAnimation: {
      true: {
        link: "relative after:bg-black after:absolute after:bottom-0 after:content after:h-[1px] after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] hover:after:scale-x-100 after:w-full after:block"
      }
    },
    navigationPlacement: {
      slider: {
        navigationButtonsWrapper: "hidden lg:flex gap-4 z-30 absolute items-center justify-between left-6 right-6"
      },
      header: {
        navigationButtonsWrapper: "flex gap-4 col-start-2 col-end-2 row-start-1 row-end-3 justify-self-end items-end",
        contentSection: "grid grid-cols-2 grid-rows-2",
        heading: "col-start-1 col-end-1 row-start-1 row-end-1",
        link: "col-start-1 col-end-1 row-start-2 row-end-2"
      },
      hide: {
        navigationButtonsWrapper: "hidden"
      }
    },
    maxWidth: {
      page: {
        base: "max-w-[calc(var(--page-max-width)+(var(--spacing-x)*2))] ml-auto mr-auto"
      }
    },
    "spacing-x": {
      zero: {
        base: "[--spacing-x:0px]",
        contentSection: "px-0",
        itemsWrapper: "px-0"
      },
      none: {
        base: "[--spacing-x:0px]",
        contentSection: "px-component-spacing-xs",
        itemsWrapper: "px-0"
      },
      xs: {
        base: "[--spacing-x:theme(space.component-spacing-xs)]",
        contentSection: "px-component-spacing-xs",
        itemsWrapper: "px-component-spacing-xs"
      },
      sm: {
        base: "[--spacing-x:theme(space.component-spacing-sm)]",
        contentSection: "px-component-spacing-sm",
        itemsWrapper: "px-component-spacing-sm"
      },
      md: {
        base: "[--spacing-x:theme(space.component-spacing-md)]",
        contentSection: "px-component-spacing-md",
        itemsWrapper: "px-component-spacing-md"
      },
      lg: {
        base: "[--spacing-x:theme(space.component-spacing-lg)]",
        contentSection: "px-component-spacing-lg",
        itemsWrapper: "px-component-spacing-lg"
      },
      xl: {
        base: "[--spacing-x:theme(space.component-spacing-xl)]",
        contentSection: "px-component-spacing-xl",
        itemsWrapper: "px-component-spacing-xl"
      }
    },
    gapY: {
      0: {
        base: "gap-y-0"
      },
      2: {
        base: "gap-y-2"
      },
      3: {
        base: "gap-y-3"
      },
      4: {
        base: "gap-y-4"
      },
      6: {
        base: "gap-y-6"
      },
      8: {
        base: "gap-y-8"
      },
      10: {
        base: "gap-y-10"
      }
    },
    gapX: {
      0: {
        base: "gap-x-0"
      },
      2: {
        base: "gap-x-2"
      },
      3: {
        base: "gap-x-3"
      },
      4: {
        base: "gap-x-4"
      },
      6: {
        base: "gap-x-6"
      }
    }
  },
  defaultVariants: {
    hasUnderlineAnimation: "true",
    "spacing-x": {
      initial: "sm",
      lg: "lg"
    },
    gapY: { initial: "4", lg: "4" },
    gapX: { initial: "3", lg: "4" }
  }
}), n = e({
  slots: {
    base: "my-component-y-spacing-lg lg:my-component-y-spacing-3xl [--keen-slider-spacing:8px] [--keen-slider-per-view:1.25] md:[--keen-slider-per-view:2] lg:[--keen-slider-per-view:3]",
    upperSection: "",
    eyebrow: "text-body-2xs uppercase",
    heading: "text-heading-2xs mb-4",
    tags: "flex flex-wrap gap-3 mb-4",
    tag: "text-label-md",
    description: "text-label-md",
    bottomSection: "w-full flex mt-auto gap-4 lg:pb-[76px]",
    link: "text-label-md border border-solid border-black rounded-full text-center flex-1 flex justify-center py-2.5 p-3 hover:bg-black hover:text-white transition-colors",
    navigationButtonsWrapper: "",
    navigationButton: "w-10 h-10 flex justify-center items-center border border-solid border-black/20 rounded-full group hover:bg-black transition-all active:scale-95",
    innerNavigationButton: "w-4 h-4 group-hover:fill-white",
    itemsWrapper: "flex overflow-hidden",
    item: "h-fit w-[calc((100%-((var(--keen-slider-per-view)-1)*var(--keen-slider-spacing)))/var(--keen-slider-per-view))] shrink-0"
  },
  variants: {
    tagHoverEffect: {
      brackets: {
        tag: "hover:after:content-[']'] after:absolute hover:before:content-['[']  before:absolute before:-translate-x-1.5 after:translate-x-0.5"
      }
    },
    navigationButtons: {
      true: {
        navigationButtonsWrapper: "gap-4 justify-between lg:justify-center lg:w-auto lg:flex"
      },
      false: {
        navigationButtonsWrapper: "hidden"
      }
    },
    maxWidth: {
      page: {
        base: "max-w-[calc(var(--page-max-width)+(var(--spacing-x)*2))] ml-auto mr-auto"
      }
    },
    "spacing-x": {
      none: {
        base: "[--spacing-x:0px]",
        bottomSection: "px-0",
        upperSection: "px-0",
        itemsWrapper: "px-0"
      },
      xs: {
        base: "[--spacing-x:theme(space.component-spacing-xs)]",
        bottomSection: "px-component-spacing-xs",
        upperSection: "px-component-spacing-xs",
        itemsWrapper: "mr-xs px-0"
      },
      sm: {
        base: "[--spacing-x:theme(space.component-spacing-sm)]",
        bottomSection: "px-component-spacing-sm",
        upperSection: "px-component-spacing-sm",
        itemsWrapper: "mr-sm px-0"
      },
      md: {
        base: "[--spacing-x:theme(space.component-spacing-md)]",
        bottomSection: "px-component-spacing-md",
        upperSection: "px-component-spacing-md",
        itemsWrapper: "mr-md px-0"
      },
      lg: {
        base: "[--spacing-x:theme(space.component-spacing-lg)]",
        bottomSection: "px-component-spacing-lg",
        upperSection: "px-component-spacing-lg",
        itemsWrapper: "mr-lg px-0"
      },
      xl: {
        base: "[--spacing-x:theme(space.component-spacing-xl)]",
        bottomSection: "px-component-spacing-xl",
        upperSection: "px-component-spacing-xl",
        itemsWrapper: "mr-xl px-0"
      }
    },
    gapY: {
      0: {
        base: "gap-y-0"
      },
      2: {
        base: "gap-y-2"
      },
      3: {
        base: "gap-y-3"
      },
      4: {
        base: "gap-y-4"
      },
      6: {
        base: "gap-y-6"
      }
    },
    gapX: {
      0: {
        base: "gap-x-0"
      },
      2: {
        base: "gap-x-2"
      },
      3: {
        base: "gap-x-3"
      },
      4: {
        base: "gap-x-4"
      },
      6: {
        base: "gap-x-6"
      }
    },
    contentCardWidth: {
      1: {
        itemsWrapper: "col-start-1 col-end-13",
        bottomSection: "col-start-1 col-end-13",
        upperSection: "col-start-1 col-end-13"
      },
      "1/4": {
        upperSection: "col-start-1 col-end-4",
        bottomSection: "col-start-1 col-end-4",
        itemsWrapper: "col-start-4 col-end-13"
      },
      "1/4-reverse": {
        upperSection: "col-start-9 col-end-13",
        bottomSection: "col-start-9 col-end-13",
        itemsWrapper: "col-start-1 col-end-9"
      },
      "1/2": {
        upperSection: "col-start-1 col-end-7",
        bottomSection: "col-start-1 col-end-7",
        itemsWrapper: "col-start-7 col-end-13"
      },
      "1/2-reverse": {
        upperSection: "col-start-7 col-end-13",
        bottomSection: "col-start-7 col-end-13",
        itemsWrapper: "col-start-1 col-end-7"
      },
      "1/3": {
        upperSection: "col-start-1 col-end-5",
        bottomSection: "col-start-1 col-end-5",
        itemsWrapper: "col-start-5 col-end-13"
      },
      "1/3-reverse": {
        upperSection: "col-start-9 col-end-13",
        bottomSection: "col-start-9 col-end-13",
        itemsWrapper: "col-start-1 col-end-9"
      }
    },
    layout: {
      default: {
        base: "grid grid-cols-12 grid-rows-[auto_auto_auto] lg:grid-rows-3 lg:grid-rows-2",
        upperSection: "flex flex-col row-start-1 row-end-2",
        bottomSection: "flex-col-reverse lg:flex-row lg:row-start-2 lg:row-end-3",
        itemsWrapper: "row-start-2 row-end-3 lg:row-start-1 lg:row-end-3"
      }
    }
  },
  defaultVariants: {
    navigationButtons: { initial: "false", lg: "true" },
    layout: "default",
    contentCardWidth: {
      initial: "1",
      lg: "1/4"
    },
    "spacing-x": {
      initial: "sm",
      lg: "lg"
    },
    tagHoverEffect: "brackets",
    gapY: { initial: "4", lg: "0" },
    gapX: { initial: "3", lg: "4" }
  }
});
export {
  a as sliderDresdenStyling,
  n as sliderSydneyStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
